import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, BarChart, Users, MapPin, TrendingUp, Target, ChevronLeft, ChevronRight, FileText, Sparkles, LogOut } from 'lucide-react';
import { logout } from '../utils/authUtils';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [{
    path: '/',
    name: 'Home',
    icon: <Home size={20} />,
    description: 'Platform Overview'
  }, {
    path: '/executive-dashboard',
    name: 'Executive View',
    icon: <BarChart size={20} />,
    description: 'High-level metrics'
  }, {
    path: '/segmentation-explorer',
    name: 'Segmentation',
    icon: <Users size={20} />,
    description: 'Customer segments'
  }, {
    path: '/trade-area-analyzer',
    name: 'Trade Areas',
    icon: <MapPin size={20} />,
    description: 'Market intelligence'
  }, {
    path: '/competitor-360',
    name: 'Competitor 360',
    icon: <TrendingUp size={20} />,
    description: 'Competitive analysis'
  }, {
    path: '/campaign-management',
    name: 'Campaigns',
    icon: <Target size={20} />,
    description: 'Campaign management'
  }];

  return <div className={`relative bg-white transition-all duration-300 ease-in-out ${collapsed ? 'w-16' : 'w-64'} h-screen shadow-lg`}>
      <div className="absolute -right-3 top-16 bg-white rounded-full p-1 shadow-md z-10 cursor-pointer" onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? <ChevronRight size={18} className="text-purple-600" /> : <ChevronLeft size={18} className="text-purple-600" />}
      </div>
      
      <div className="p-5 flex flex-col items-center">
        <div className={`flex ${collapsed ? 'justify-center' : 'justify-start w-full'} items-center`}>
          <div className={`${collapsed ? 'w-8 h-8 mb-2' : 'w-8 h-8 mr-3'} flex items-center justify-center`}>
            <img src="/image-uploads/0460b37c-0857-45eb-844c-0ef9899d87c7.png" alt="Accenture Logo" className="w-full h-full object-contain" />
          </div>
          <h1 className={`font-bold text-purple-900 transition-all ${collapsed ? 'text-lg' : 'text-xl'}`}>
            {collapsed ? 'F.AI' : 'Fuel.AI'}
          </h1>
        </div>
      </div>
      
      <div className="mt-6 space-y-1 px-3">
        {navItems.map(item => <Link key={item.path} to={item.path} className={`flex items-center py-3 px-3 rounded-lg transition-all duration-200 ${location.pathname === item.path ? 'bg-purple-50 text-purple-700' : 'text-gray-700 hover:bg-gray-100'}`}>
            <span className={`${location.pathname === item.path ? 'text-purple-600' : 'text-gray-500'}`}>
              {item.icon}
            </span>
            
            {!collapsed && <div className="ml-3 transition-all">
                <div className={`font-medium ${location.pathname === item.path ? 'text-purple-900' : 'text-gray-800'}`}>
                  {item.name}
                </div>
                {item.description && <div className="text-xs text-gray-500 truncate">{item.description}</div>}
              </div>}
          </Link>)}
      </div>
      
      <div className={`mt-auto p-3 ${collapsed ? 'mx-2' : 'mx-3'} mb-5 bg-purple-50 rounded-lg`}>
        {collapsed ? <div className="flex justify-center py-3">
            <Sparkles size={20} className="text-purple-600" />
          </div> : <>
            <h3 className="text-sm font-medium text-purple-900 mb-2">Fuel.AI Platform</h3>
            <p className="text-xs text-gray-600 mb-3">AI-powered fuel intelligence</p>
            <Link to="/documentation" className="flex items-center text-xs text-purple-700 font-medium hover:text-purple-900">
              <FileText size={14} className="mr-1" />
              View Documentation
            </Link>
          </>}
      </div>
      
      <div className="mt-auto">
        <button
          onClick={handleLogout}
          className="w-full flex items-center py-3 px-3 text-gray-700 hover:bg-gray-100 cursor-pointer"
        >
          <LogOut size={20} className="text-gray-500" />
          {!collapsed && <span className="ml-3">Logout</span>}
        </button>
      </div>
    </div>;
};

export default Navigation;
